import './wg_ajax_extention';
import _ from '../lib/underscore_extend';
import {Model, sync} from 'backbone';

var BaseModel = Model.extend({
    initialize: function(attr={}, options={}) {
        Model.prototype.initialize(this, arguments);
        this.Url = this.Url || options.Url || '/';
        this.validators = options.validators;
    },
    url: function() {
        var url;

        if (_.isFunction(this.Url)) {
            url = this.Url(this.urlOption);
        } else {
            url = this.Url;
        }
        return url;
    },
    getQueryString: function(options = {}) {
        return '';
    },
    sync: function(method, model, options) {
        if (!options.url && _.isFunction(this.url)) {
            options.url = this.url(options);
        }
        options.data = options.data || options.attrs || this.toJSON(options);
        Model.prototype.sync.apply(this, arguments);
    },
    validate: function(attrs={}, options={}) {
        var errors = {},
            error,
            hasError = false;

        if (_.isArray(this.validators)) {
            _.each(this.validators, (validator) => {
                error = validator(attrs, options, errors);
                if (error) {
                    hasError = true;
                    _.each(error, (msgs, field) => {
                        errors[field] = errors[field] ? _.unique(errors[field].concat(msgs)) : msgs;
                    });
                }
            });
        }
        return hasError ? errors : false;
    },
    parse: function() {}
});

export default BaseModel;



// WEBPACK FOOTER //
// ./~/wgnet-awesomejs/base/model.js